import Cleave from 'cleave.js';

export default function telField(element, data) {
    const cleave = new Cleave(element, {
        prefix: '+7',
        delimiters: [' (', ') ', '-', '-'],
        blocks: [2, 3, 3, 2, 2],
        numericOnly: true,
        noImmediatePrefix: true,
    });

    element.closest("form").addEventListener("clear", function () {
        cleave.setRawValue("");
        // На Android Cleave пишет значение в поле через setTimeout(…,1),
        // поэтому синхронная очистка перетирается — чистим тоже отложенно.
        setTimeout(() => { element.value = ""; }, 20);
    })
};
